import styled from 'styled-components';
import { Info } from 'styled-icons/octicons/Info';
import { Book } from 'styled-icons/fa-solid/Book';
import { FolderOpen } from 'styled-icons/fa-solid/FolderOpen';
import { LibraryBooks } from 'styled-icons/material/LibraryBooks';
import { Assessment } from 'styled-icons/material/Assessment';
import { Home } from 'styled-icons/feather/Home';
import { Documentation } from 'styled-icons/boxicons-solid/Documentation';
import { ExternalLinkAlt } from 'styled-icons/fa-solid/ExternalLinkAlt';
import { Plus } from 'styled-icons/boxicons-regular/Plus';
import { HighlightedRow } from './styled-row';

export const InfoIcon = styled(Info)`
  cursor: pointer;
  visibility: hidden;
  ${HighlightedRow}:hover & {
    visibility: visible;
  }
`;

export const ProgramIcon = styled(Book)`
  color: #737373;
`;

export const ChapterIcon = styled(FolderOpen)`
  color: #cccc00;
`;

export const BlockIcon = styled(LibraryBooks)`
  color: #785027;
`;

export const LessonIcon = styled(Documentation)`
  color: #b5651d;
`;

export const HomeworkIcon = styled(Home)`
  color: #000089;
`;

export const AssessmentIcon = styled(Assessment)`
  color: #009900;
`;

export const TestIcon = styled(ExternalLinkAlt)`
  cursor: pointer;
  color: #7f0000;
  visibility: hidden;
  ${HighlightedRow}:hover & {
    visibility: visible;
  }
`;

export const PlusIcon = styled(Plus)`
  cursor: pointer;
`;
